import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './Profecionales.css';
import baseURL from '../../url';
import NewProfesional from './NewProfesional';

export default function Profecionales() {
    const [profesionales, setProfesionales] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [profesional, setProfesional] = useState({});
    const [search, setSearch] = useState('');

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        try {
            // Cargamos profesionales y categorías en paralelo
            const [resProf, resCat] = await Promise.all([
                fetch(`${baseURL}/profesionalesGet.php`),
                fetch(`${baseURL}/categoriasGet.php`)
            ]);
            const dataProf = await resProf.json();
            const dataCat = await resCat.json();
            
            setProfesionales(dataProf.profesionales || []);
            setCategorias(dataCat.categorias || []);
        } catch (err) {
            console.error("Error cargando datos:", err);
        }
    };

    const eliminarProfesionale = (id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id', id);
                fetch(`${baseURL}/profesionalDelete.php`, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {
                    if(data.error) Swal.fire('Error', data.error, 'error');
                    else {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarDatos();
                    }
                });
            }
        });
    };

    const abrirModal = (item = {}) => {
        setProfesional(item);
        setModalVisible(true);
    };

    // Función para mostrar los nombres de las categorías asignadas en la tabla
    const obtenerNombresCategorias = (catJson) => {
        if (!catJson) return "Sin categorías";
        try {
            const ids = typeof catJson === 'string' ? JSON.parse(catJson) : catJson;
            if (!Array.isArray(ids)) return "Sin categorías";
            
            return ids.map(id => {
                const cat = categorias.find(c => c.idCategoria == id);
                return cat ? cat.categoria : null;
            }).filter(n => n).join(", ");
        } catch (e) { return "Error en formato"; }
    };

    const profesionalesFiltrados = profesionales.filter(p =>
        p.nombre.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="profesionales-container">
            <ToastContainer />
            <div className="profesionales-header">
                <h2><FontAwesomeIcon icon={faUserTie} /> Gestión de Profesionales</h2>
                <div className="profesionales-search">
                    <input
                        type="text"
                        placeholder="Buscar profesional..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button className="btn btn-add" onClick={() => abrirModal()}>Nuevo profesional</button>
                </div>
            </div>

            {modalVisible && (
                <NewProfesional 
                    profesional={profesional} 
                    categorias={categorias} // Pasamos las categorías al modal
                    cerrarModal={() => setModalVisible(false)} 
                    recargar={cargarDatos} 
                />
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Categorías asignadas</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {profesionalesFiltrados.map(p => (
                            <tr key={p.id}>
                                <td>{p.nombre}</td>
                                <td>
                                    <div className="tags-container">
                                        {obtenerNombresCategorias(p.categorias)}
                                    </div>
                                </td>
                                <td>
                                    <button className="editar" onClick={() => abrirModal(p)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className="eliminar" onClick={() => eliminarProfesionale(p.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}